import { createServerClient } from '@supabase/ssr'
import { cookies } from 'next/headers'

import { env } from '@/env'

import { type Database } from './schema'

const serverClient = (cookieStore: Awaited<ReturnType<typeof cookies>>) => {
  const supabase = createServerClient<Database>(
    env.NEXT_PUBLIC_SUPABASE_URL,
    env.SUPABASE_SERVICE_ROLE_KEY,
    {
      cookies: {
        getAll() {
          return cookieStore.getAll()
        },
        setAll(cookiesToSet) {
          try {
            cookiesToSet.forEach(({ name, value, options }) =>
              cookieStore.set(name, value, options),
            )
          } catch {
            // The `setAll` method was called from a Server Component.
            // This can be ignored if you have middleware refreshing
            // user sessions.
          }
        },
      },
    },
  )

  return supabase
}

export default serverClient
